import React from "react";
import "./styles.less";

export const ApplicationBanner = (props) => {
  const { title, subtitle, img, alt, character, name } = props;
  return (
    <div className="application-banner">
      <div className="inner">
        <div className="banner-content">
          <h1 className="slogn">{title}</h1>
          <div className="descrption">{subtitle}</div>
          <div className="descrption character">{character}</div>
        </div>
        <div className={`banner-img`}>
          <img src={img} alt={alt} />
        </div>
      </div>
      <div className="bg-img">
        {/* <img
          src="//files.authing.co/authing-website/marketplace-banner-img-bg.png"
          alt="authing"
        /> */}
      </div>
    </div>
  );
};
